export enum TreatmentDocumentSize {
    HalfLetter = 1,
    Letter,
    Legal
}